import { render, staticRenderFns } from "./FlockNavigation.vue?vue&type=template&id=05cc499f&scoped=true&"
import script from "./FlockNavigation.vue?vue&type=script&lang=js&"
export * from "./FlockNavigation.vue?vue&type=script&lang=js&"
import style0 from "./FlockNavigation.vue?vue&type=style&index=0&id=05cc499f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cc499f",
  null
  
)

export default component.exports